var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apex-chart',{attrs:{"type":"line","height":"350","options":_vm.c_options,"series":_vm.c_series}})}
var staticRenderFns = []

export { render, staticRenderFns }